module.exports = __webpack_public_path__ + "img/footer-logo.1d57665a.png";